import { configureStore, combineReducers } from "@reduxjs/toolkit";
import api from "../utils/rtk";
import { authReducer } from "../reducers";

const appReducer = combineReducers({
  auth: authReducer,
  [api.reducerPath]: api.reducer,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/resetAuth") {
    state = undefined; // Reset state
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(api.middleware),
});

// Optional helper exports
export const dispatch = store.dispatch;
